/*
  TWRD reviews (PDP module C).

  Klaviyo can be installed two ways on this store: as a theme app block, or as
  the documented <div id="klaviyo-reviews-all"> embed. If an app block review
  widget is already on the page we move it into our mount and drop our own
  embed, so the page never shows the review list twice.
*/
(function () {
  if (window.__twrdReviewsInit) return;
  window.__twrdReviewsInit = true;

  var APP_BLOCK = [
    'app-block[id*="klaviyo_reviews_product_reviews"]',
    'div[id*="klaviyo_reviews_product_reviews"]',
    '.shopify-app-block[id*="klaviyo_reviews"]'
  ].join(', ');

  function adopt() {
    var mount = document.querySelector('[data-twrd-rev-widget]');
    if (!mount || mount.getAttribute('data-adopted') === 'done') return;

    var block = document.querySelector(APP_BLOCK);
    if (!block || mount.contains(block)) return;

    var embed = mount.querySelector('#klaviyo-reviews-all');
    if (embed && embed.parentNode) embed.parentNode.removeChild(embed);

    mount.appendChild(block);
    mount.setAttribute('data-adopted', 'done');
  }

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  /* No widget markup means an empty bordered block. Hide it. */
  function prune() {
    var mount = document.querySelector('[data-twrd-rev-widget]');
    if (!mount) return;
    var content = 0;
    for (var i = 0; i < mount.children.length; i++) {
      content += mount.children[i].getBoundingClientRect().height;
    }
    var empty = content < 8;
    if (empty) mount.setAttribute('hidden', '');
    else mount.removeAttribute('hidden');
  }

  ready(function () {
    adopt();
    prune();
    setTimeout(prune, 4000);
    setTimeout(prune, 12000);
    /* Klaviyo injects late on slow networks. Watch for a while, then stop. */
    if (!window.MutationObserver) return;
    var observer = new MutationObserver(function () { adopt(); prune(); });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 20000);
  });
})();
